var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingQueueContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76 39.9999C76 47.12 73.8886 54.0802 69.9329 60.0003C65.9772 65.9205 60.3547 70.5347 53.7766 73.2594C47.1984 75.9842 39.9601 76.6971 32.9767 75.308C25.9934 73.919 19.5789 70.4903 14.5442 65.4556C9.50948 60.421 6.08082 54.0064 4.69175 47.0231C3.30269 40.0398 4.01557 32.8014 6.74033 26.2233C9.46508 19.6452 14.0793 14.0228 19.9995 10.0671C25.9197 6.11136 32.8799 4 40 4C49.5471 4.00207 58.7027 7.79557 65.4536 14.5464C72.2044 21.2972 75.9979 30.4527 76 39.9999Z",
    stroke: "#B3B3B7",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeDasharray: "0.75 7.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingQueueContainer);
export default __webpack_public_path__ + "static/media/training-queue-container.7a4674dd421865e1ca4edf3c85b2ac7a.svg";
export { ForwardRef as ReactComponent };